import {insertCodeBlockChangeSet} from "./codeBlock.js";

export const insertCodeBlock = insertCodeBlockChangeSet((mark, text) => ({
  insert: mark + '\n' + text + '\n' + mark,
  cursor: mark.length
}));

export const insertCodeBlockIgnoreCodeInfo = insertCodeBlockChangeSet((mark, text) => ({
  insert: mark + '\n' + text + '\n' + mark,
  cursor: mark.length + 1 + text.length
}));
